// import { useEffect, useState } from "react";
// import "./EcaServicesLanding.css";

// export default function EcaServicesLanding() {
//   const [services, setServices] = useState([]);
//   const [active, setActive] = useState(null);

//   useEffect(() => {
//     fetch("http://localhost:3008/getecaservices")
//       .then(res => res.json())
//       .then(data => {
//         setServices(data);
//         setActive(data[0]);
//       });
//   }, []);

//   const openDetailsById = async (id) => {
//     const res = await fetch(`http://localhost:3008/getecaservices/${id}`);
//     const data = await res.json();
//     console.log("FULL DETAILS:", data);
//   };

//   if (!services.length || !active) return null;

//   return (
//     <section className="container eca-wrapper">

//       {/* ✅ TOP HEADER */}
//       <div className="eca-header">
//         <div>
//           <h2 className="fw-bold">Explore Our Specialized Services</h2>
//           <p>
//             Comprehensive corrosion, coating, and asset protection solutions
//             designed to enhance reliability, extend asset life, and ensure
//             long-term performance.
//           </p>
//         </div>

//         <button className="eca-view-all">View All →</button>
//       </div>

//       {/* ✅ MAIN CONTENT */}
//       <div className="eca-landing-grid">

//         {/* ✅ LEFT BIG CARD */}
//         <div className="eca-left">
//           <img
//             src={active.landing.image}
//             className="eca-main-image"
//             alt=""
//           />

//           <h3>{active.landing.title}</h3>
//           <p>{active.landing.shortDesc}</p>

//           <button
//             className="eca-learn-more"
//             onClick={() => openDetailsById(active._id)}
//           >
//             Learn More →
//           </button>
//         </div>

//         {/* ✅ RIGHT SCROLLABLE CARDS */}
//         <div className="eca-right-scroll">
//           {services.map(item => (
//             <div
//               key={item._id}
//               className={`eca-scroll-card ${
//                 active._id === item._id ? "active" : ""
//               }`}
//               onClick={() => setActive(item)}
//             >
//               <img src={item.landingCards.image} alt="" />

//               <div className="eca-scroll-text">
//                 <h4>{item.landingCards.title}</h4>
//                 <p>{item.landingCards.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./EcaServicesLanding.css";

export default function EcaServicesLanding() {
  const [services, setServices] = useState([]);
  const [active, setActive] = useState(null);
  const navigate = useNavigate(); // ✅ ADDED

  useEffect(() => {
    fetch("https://agepcoatings.com/getecaservices")
      .then((res) => res.json())
      .then((data) => {
        setServices(data);
        setActive(data[0]);
      });
  }, []);

  // ✅ NOW THIS REDIRECTS TO SERVICES PAGE WITH ID
  const openDetailsById = (id) => {
    navigate("/services", { state: { activeId: id } });
  };

  if (!services.length || !active) return null;

  return (
    <section className="container eca-wrapper">
      {/* ✅ TOP HEADER */}
      <div className="eca-header">
        <div>
          <h2 className="fw-bold">Explore Our Specialized Services</h2>
          <p>
            Comprehensive corrosion, coating, and asset protection solutions
            designed to enhance reliability, extend asset life, and ensure
            long-term performance.
          </p>
        </div>

        <button className="eca-view-all" onClick={() => navigate("/services")}>
          View All →
        </button>
      </div>

      {/* ✅ MAIN CONTENT */}
      <div className="eca-landing-grid">
        {/* ✅ LEFT BIG CARD */}
        <div className="eca-left">
          <img src={active.landing.image} className="eca-main-image" alt="" />

          <h3>{active.landing.title}</h3>
          <p>{active.landing.shortDesc}</p>

          <button
            className="eca-learn-more"
            onClick={() => openDetailsById(active._id)}
          >
            Learn More →
          </button>
        </div>

        {/* ✅ RIGHT SCROLLABLE CARDS */}
        <div className="eca-right-scroll">
          {services.map((item) => (
            <div
              key={item._id}
              className={`eca-scroll-card ${
                active._id === item._id ? "active" : ""
              }`}
              onClick={() => setActive(item)}
            >
              <img src={item.landingCards.image} alt="" />

              <div className="eca-scroll-text">
                <h4>{item.landingCards.title}</h4>
                <p>{item.landingCards.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
